import { IAppState } from '../../common/state';
import { AUDIENCE_2023_Q1_CONTROL } from '../../constants/experiments';
import { isAbUseExperimentGroup } from '../../utils/experiments/isAbUseExperimentGroup';
import { abUseExperimentsSelector } from '../commonSelectors';

export function selectIsAudienceControlEnabled(state: IAppState): boolean {
  const experiments = abUseExperimentsSelector(state);

  return (
    isAbUseExperimentGroup(experiments, AUDIENCE_2023_Q1_CONTROL, 'A') ||
    isAbUseExperimentGroup(experiments, AUDIENCE_2023_Q1_CONTROL, 'B')
  );
}
